import axiosInstance from "../configs/axios/axiosInstance";

const UsersServices = {

    getUsers: async (filters: any) => {    
        const response = await axiosInstance.get('Users/GetUsersList',  {params: filters});
        return response.data;
    },


    createUser: async (payload: any) => {   
        const response = await axiosInstance.post('Users/AddUser', payload);
        return response.data;
    },

    updateUser: async (payload: any) => {   
        const response = await axiosInstance.put('Users/UpdateUser', payload);
        return response.data;
    },

    getRoles: async (filters: any) => {      
        const params = { roleName: filters.roleName};
        const response = await axiosInstance.get('Users/GetRoles', {params: params});
        return response.data;
    },

     createRole: async (payload: any) => {   
        const response = await axiosInstance.post('Users/AddRole', payload);
        return response.data;
    },

    updateRole: async (payload: any) => {   
        const response = await axiosInstance.put('Users/UpdateRole', payload);
        return response.data;
    },

    getUserLocalFiles: async (userID: string) => {
        const params = { userID };
        const response = await axiosInstance.get('LocalFiles/GetUserLocalFiles', { params: params });
        return response.data;
    },


    updateUserLocalFile: async (payload: any) => {
        const response = await axiosInstance.post('LocalFiles/AssignLocalFilesToUser', payload);
        return response.data;
    },


};

export default UsersServices;
